import { i18nService } from "../services/i18n";

export const useLanguages = () => {
  const lng = i18nService.getLanguages();

  return lng;
};
